module.exports = __webpack_public_path__ + "static/media/login_img3.2e0371dc.jpg";